<template>
  <v-app>

    <v-navigation-drawer v-model="drawer" absolute app temporary dark color="#343a40">

      <p></p>
      <v-list>
        <div>
          &nbsp;
        </div>
        <div>
          &nbsp;
        </div>
        <div>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Company</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item link href="https://www.amphenol.com/" target="_blank">
                <v-list-item-title>Amphenol Worldwide</v-list-item-title>
              </v-list-item>
              <v-list-item link href="https://www.amphenol.com/docs/code-of-business-conduct-and-ethics" target="_blank">
                <v-list-item-title>Code of Business Conduct and Ethics</v-list-item-title>
              </v-list-item>
              <v-list-item link href="docs/GTC_Amphenol_Connexus_AB_v2.pdf" target="_blank">
                <v-list-item-title>Terms and Conditions of Sale</v-list-item-title>
              </v-list-item>
              <v-list-item link to="/loc" exact>
                <v-list-item-title>Location</v-list-item-title>
              </v-list-item>
              <v-list-item link to="/quality" exact>
                <v-list-item-title>Quality and Environmental Policy</v-list-item-title>
              </v-list-item>
              <v-list-item link to="/privacy" exact>
                <v-list-item-title>Privacy Policy</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list-group>
        </div>
        <div>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Products</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item link to="/standards" exact>
                <v-list-item-title>Quality and Standards</v-list-item-title>
              </v-list-item>
              <v-list-item link to="/highspeed" exact>
                <v-list-item-title>High Speed Cables</v-list-item-title>
              </v-list-item>
              <v-list-item link to="/industrial" exact>
                <v-list-item-title>Industrial Cables</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list-group>
        </div>
        <div>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Vendors</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item link to="/docsforsuppl" exact>
                <v-list-item-title>Documents for Suppliers</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list-group>
        </div>
        <div>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Contact</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item href="mailto:info[]amphenol.se">
                <v-list-item-title>Contact e-mail</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list-group>
        </div>
      </v-list>


    </v-navigation-drawer>

    <v-app-bar app color="#343a40" dark style="height:fit-content;">

      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-app-bar-nav-icon>



      <v-spacer></v-spacer>
      <div class="hidden-xs-only align-center" style="height: 70px;">
        <router-link class="caption1" to="/" exact>Amphenol ConneXus</router-link>
        <v-row>
          <span class="subcaption"> Cable assembly supplier </span>
        </v-row>
      </div>
      <div class="hidden-sm-and-up align-center">
        <v-row>
          <a href="/" class="caption2"> Amphenol ConneXus </a>
        </v-row>
        <v-row>
          <span class="subcaption"> cable assembly supplier </span>
        </v-row>
      </div>
      <v-spacer></v-spacer>

      <div class="text-center hidden-sm-and-down">
        <v-menu open-on-hover bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn plain v-bind="attrs" v-on="on">
              Company
            </v-btn>
          </template>
          <v-list>
            <v-list-item link href="https://www.amphenol.com/" target="_blank">
              <v-list-item-title>Amphenol Worldwide</v-list-item-title>
            </v-list-item>
            <v-list-item link href="https://www.amphenol.com/docs/code-of-business-conduct-and-ethics" target="_blank">
              <v-list-item-title>Code of Business Conduct and Ethics</v-list-item-title>
            </v-list-item>
            <v-list-item link href="https://www.amphenol.ee/docs/GTC_Amphenol_Connexus_AB_v2.pdf" target="_blank">
              <v-list-item-title>Terms and Conditions of Sale</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/loc" exact>
              <v-list-item-title>Location</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/quality" exact>
              <v-list-item-title>Quality and Environmental Policy</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/privacy" exact>
              <v-list-item-title>Privacy Policy</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div class="text-center hidden-sm-and-down">
        <v-menu open-on-hover bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn plain v-bind="attrs" v-on="on">
              Products
            </v-btn>
          </template>
          <v-list>
            <v-list-item link to="/standards" exact>
              <v-list-item-title>Quality and Standards</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/highspeed" exact>
              <v-list-item-title>High Speed Cables</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/industrial" exact>
              <v-list-item-title>Industrial Cables</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div class="text-center hidden-sm-and-down">
        <v-menu open-on-hover bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn plain v-bind="attrs" v-on="on">
              Vendors
            </v-btn>
          </template>
          <v-list>
            <v-list-item link to="/docsforsuppl" exact>
              <v-list-item-title>Documents for Suppliers</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div class="text-center hidden-sm-and-down">
        <v-menu open-on-hover bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn plain v-bind="attrs" v-on="on">
              Contact
            </v-btn>
          </template>
          <v-list>
            <v-list-item href="mailto:info[]amphenol.se">
              <v-list-item-title>e-mail</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>



    <v-main style="background-color: #e9ecef;">
      <p></p>
      <p></p>
      <router-view />
      <p></p>
      <p></p>
    </v-main>

    <template>
      <v-footer padless>
        <v-card class="flex" flat>
          <v-card-text class="py-1">
            <v-row>&nbsp;</v-row>
            <v-row>
              <v-col class="hidden-xs-only align-center"></v-col>
              <v-col>
                <h2>About Amphenol</h2>
                <div>&nbsp;</div>
                <div>
                  <router-link to="/" class="links">Our Company</router-link>
                </div>
                <div>
                  <a href="https://www.amphenol.com/" target="_blank" class="links">Amphenol Worldwide</a>
                </div>
                <div>
                  <a href="https://cablesondemand.com/" target="_blank" class="links">Amphenol Cables On
                    Demand</a>
                </div>
              </v-col>
              <v-col>
                <h2>Customer Support</h2>
                <div>&nbsp;</div>
                <div>
                  <a href="mailto:info[]amphenol.se">Contact</a>
                </div>
                <div>
                  <router-link to="/loc" class="links">Locations</router-link>
                </div>
              </v-col>
              <v-col class="hidden-xs-only"></v-col>
            </v-row>

            <v-row>
              <v-col class="hidden-xs-only align-center"></v-col>
              <v-col>
                <strong>© {{ new Date().getFullYear() }} Amphenol ConneXus AB</strong>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="hidden-xs-only align-center"></v-col>
              <v-col>
                <router-link to="/privacy" class="links">Privacy Policy</router-link>
              </v-col>
              <v-col>
                <router-link to="/terms" class="links">Terms of use</router-link>
              </v-col>
              <v-col>
              </v-col>
            </v-row>
            <v-row>&nbsp;</v-row>
          </v-card-text>
        </v-card>
      </v-footer>
    </template>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
    drawer: false,
    group: null,

  }),
  watch: {
    group() {
      this.drawer = false
    },
  },
};
</script>

<style>
.caption1 {
  color: #82A3FF;
  font-size: 40px;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
  text-decoration: none;
  white-space: nowrap;
}

.caption2 {
  color: #82A3FF;
  font-size: 20px;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
  text-decoration: none;
  white-space: nowrap;
}

.subcaption {
  color: white;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
  white-space: nowrap;
}

.links {
  white-space: nowrap;
  color: black;
  text-decoration: none;
}
</style>